import LAZY_DISP from "../plugins/lazydisp";
import TOGGLE_DRAWER from "../plugins/toggleDrawer";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

import SCROLL from '../plugins/scroll';

//pictureタグ使用時にIE11で画像サイズ指定
import IE_SRCSET from '../plugins/polyfill-ie-srcset'

// カレントメニュー
import CURRENT_NAV from "../plugins/currentNav";
import PAGETRANSITION from "../plugins/pagetransition";

const [w,d] = [window,document];

const init = () => {
  d.documentElement.classList.remove('no-js');
  PAGETRANSITION();
  d.documentElement.classList.add('is-loading');
  w.addEventListener('load',()=> d.documentElement.classList.remove('is-loading'));

  gsap.registerPlugin(ScrollTrigger);

}

const subnav = () => {

  // gnav indicator
  $('header .gnav__item').each( function(){
    const $indicator = $(`<button class="gnav__item__indicator btn btn-text">`)
    if( this.querySelectorAll('.subgnav').length ) {
      $(this).append( $indicator )
    }
    $(this).find('.subgnav').slideUp();
    $indicator.on('click', ()=>{
      $(this).find('.subgnav').slideToggle()
      $indicator.toggleClass('is-active')
    });
  });

  // footerNav indicator
  $('footer .footerNav__item').each( function(){
    const $indicator = $(`<button class="footerNav__item__indicator btn btn-text">`)
    if( this.querySelectorAll('.subfnav').length ) {
      $(this).append( $indicator )
    }
    $(this).find('.subfnav').slideUp();
    $indicator.on('click', ()=>{
      $(this).find('.subfnav').slideToggle()
      $indicator.toggleClass('is-active')
    });
  });

}

const popupWindow = () => {
  $('[data-plugin="openwindow"]').on('click', (e) => {
    e.preventDefault();
    var $this = $(e.currentTarget),
        data = $this.data(),
        size = 'width='+(data.width||600)+', height='+(data.height||500)+',';
    w.open(e.currentTarget.href,(data.title||'share this site'),size+"menubar=no, toolbar=no, scrollbars=yes");
  });
}

const togglePagetop = () => {
  ScrollTrigger.create({
    trigger: 'body', // 要素"body"がビューポートに入ったときにアニメーション開始
    start: 'top -=70%', // アニメーション開始位置
    markers: false, // マーカー表示
    onEnter() {
      $('.pagetop__wrap').removeClass('hidden');
    },
    onLeaveBack() {
      $('.pagetop__wrap').addClass('hidden');
    },
  });
}

export default function INIT () {

  init();

  //ドロワーナビ
  TOGGLE_DRAWER();

  //polyfill-ie-srcset
  IE_SRCSET();

  // lazydisp
  LAZY_DISP('[data-lazydisp]');

  // currentクラス付与
  CURRENT_NAV('.gnav,[data-plugin="currentNav"],[data-plugin="currentMenu"]');

  // 下層ナビゲーション
  $( subnav );

  // ポップアップウインドウ
  $( popupWindow );

  // pagetopをスクロールで表示・非表示
  d.addEventListener('DOMContentLoaded', togglePagetop );

  // スクロールイベント
  SCROLL();
}

window.WebFontConfig = {
  google: {
    families: ['Montserrat:400,600', 'Roboto:400', 'Noto+Sans+JP:400,600,700']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();